import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconArrowLeftSharp = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m11.707 16.293.707.708L11 18.414l-.707-.707-5-5.006-.706-.707.707-.707 5-4.995.708-.706L12.414 7l-.707.706L8.41 11h11.38v2H8.417l3.29 3.293Z"
      clipRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgIconArrowLeftSharp);
export default Memo;
